import React from "react";
import SectionHeading from "../components/SectionHeading";
import Reveal from "../components/Reveal";

const PRINCIPLES = [
  { t: "Evidence-informed", d: "Plain-language translation of current clinical guidance and published research." },
  { t: "Clinician-written", d: "Written and reviewed by a registered nurse, not a marketing team." },
  { t: "No hype", d: "No miracle claims, no fear-based marketing. Sources cited." },
];

export default function About() {
  return (
    <div data-testid="page-about" className="pt-32 md:pt-40 pb-24">
      <section className="px-6 md:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <Reveal className="md:col-span-7">
            <SectionHeading
              overline="About SERENATTI"
              title="Written by a nurse who reads the research."
            />
            <div className="mt-8 space-y-5 text-lg text-charcoal/85 leading-relaxed max-w-2xl">
              <p>
                SERENATTI was founded by a registered nurse currently completing
                advanced practice nursing education. The goal is simple: give
                people accurate, understandable health and skincare information
                &mdash; the kind that&rsquo;s usually buried behind marketing.
              </p>
              <p>
                Every article here is written in plain language, based on
                published research, and cites its sources. Nothing on this site
                is for sale, and no products are recommended for profit.
              </p>
            </div>
          </Reveal>

          <Reveal className="md:col-span-5" delay={150}>
            <div className="relative">
              <div className="absolute -top-4 -right-4 w-32 h-32 border border-gold/60 hidden md:block" />
              <img
                src="https://images.pexels.com/photos/6129444/pexels-photo-6129444.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=940"
                alt="Reading research"
                className="relative w-full h-[460px] md:h-[600px] object-cover rounded-sm shadow-lg"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="mt-24 px-6 md:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {PRINCIPLES.map((v, i) => (
            <div key={v.t} data-testid={`about-principle-${i}`} className="bg-white border border-navy/10 p-8 rounded-sm">
              <p className="text-[11px] tracking-[0.25em] uppercase text-gold">Principle 0{i + 1}</p>
              <h3 className="mt-2 font-heading text-2xl text-navy">{v.t}</h3>
              <p className="mt-3 text-sm text-charcoal/75 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
